import type { Blocker } from 'react-router'
import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import { type ReactNode } from 'react'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'

export class BlockerStore {
  _cachedParams
  constructor(
    private parent: { params: unknown; disabled?: boolean },
    private config: {
      title: ReactNode
      primaryAction: (modalId: string) => Promise<unknown>
      primaryText: string
      additionalSecondaryActionText?: string
      modalType?: ModalTypeList
    }
  ) {
    this._cachedParams = JSON.stringify(parent.params)
    makeAutoObservable(this)
  }

  get isExistChanges() {
    return this._cachedParams !== JSON.stringify(this.parent.params)
  }

  updateCash = () => {
    this._cachedParams = JSON.stringify(this.parent.params)
  }

  handleShowBlockerModal = (blocker: Blocker) => {
    if (!this.config) return
    if (blocker.state !== 'blocked') return

    const modalId = nanoid()
    const onNext = () => {
      blocker.proceed()
      modalStore.closeModal(modalId)
    }

    modalStore.addModal({
      id: modalId,
      type: this.config?.modalType ?? ModalTypeList.INFO,
      title: this.config.title,
      primaryAction: {
        text: this.config.primaryText,
        onAction: async () => {
          try {
            await this.config?.primaryAction(modalId)
            onNext()
          } catch (e) {
            logger.error(e)
            modalStore.closeModal(modalId)
          }
        },
      },
      additionalSecondaryAction: {
        text: this.config.additionalSecondaryActionText ?? 'Don’t save',
        onAction: onNext,
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => {
          modalStore.closeModal(modalId)
        },
      },
    })
  }
}
